import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section className="banner_h100 nurs_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="logo_nurs">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={199}
                height={153}
              />
            </div>
            <h1>The Idea That Led Us To Build The Nurse Practitioners App</h1>
            <p>
              In today’s digital age, you don’t have to go to a medical
              facility. Why would you physically go out when you can call a
              nurse or a medic at home through an application? Yes, it is that
              easy through the Nurse Practitioners app.
            </p>
            <p>
              At TekRevol, our experience in developing digital solutions,
              specifically in the healthcare and fitness domains, has enabled us
              to gain experience and build better products. Counting on our
              strengths, we built the Nurse Practitioners application that makes
              it easy for anyone to call a nurse or a medic to their home easily
              using the purpose-built and feature-packed mobile app.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={661}
                height={733}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
